<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'roodie-safe' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-title>Termine & Ärzte</ion-title>
        <ion-button
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
      <ion-toolbar class="-not-fixed">
        <ion-segment v-model="selectedSegment">
          <ion-segment-button value="appointments">
            <ion-label>Termine</ion-label>
          </ion-segment-button>
          <ion-segment-button value="doctors">
            <ion-label>Ärzte</ion-label>
          </ion-segment-button>
          <ion-segment-button value="proposed">
            <ion-label>Vorschläge</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid>
        <template v-if="selectedSegment === 'appointments'">
          <p v-if="!$store.state.showLoading && appointments.length === 0">
            Sie haben aktuell keine Termine gespeichert.
          </p>
          <ion-list v-else lines="none">
            <div
              v-for="(appointment, appointmentIndex) in appointments"
              :key="appointmentIndex"
              class="u-border"
            >
              <ion-item>
                <ion-label class="ion-text-wrap">
                  <h2>
                    <b v-if="appointment.Type === 'clinic'">{{
                      appointment.Clinicname
                    }}</b>
                    <b v-else-if="appointment.IsUserAppointmentOnly">{{
                      appointment.AppointmentSubject
                    }}</b>
                    <b v-else
                      >{{ appointment.Surname }} {{ appointment.Firstname }},
                      {{ appointment.Title }}</b
                    >
                  </h2>
                  <div style="margin: 5px 0">
                    <template v-if="appointment.Type === 'clinic'">
                      <div v-if="appointment.Clinicdivision">
                        Abteilung: {{ appointment.Clinicdivision }}
                      </div>
                      <div v-if="appointment.Firstname || appointment.Surname">
                        Behandelnder Arzt: {{ appointment.Title }}
                        {{ appointment.Firstname }} {{ appointment.Surname }}
                      </div>
                    </template>
                    <div v-if="appointment.Specialty">
                      {{ appointment.Specialty }}
                    </div>
                    <div v-if="!appointment.IsUserAppointmentOnly">
                      {{ appointment.Street }} {{ appointment.Housenumber
                      }}<br />
                      {{ appointment.Zip }} {{ appointment.City }}
                    </div>
                  </div>
                  <div>
                    <a :href="'mailto:' + appointment.Email">{{
                      appointment.Email
                    }}</a>
                  </div>
                  <div>
                    <a :href="'tel:' + appointment.Phone">{{
                      appointment.Phone
                    }}</a>
                  </div>
                  <template v-if="appointment.nextDate">
                    <p style="margin-top: 10px">
                      <b>Nächster Termin:</b>
                      <br />
                      {{
                        DateFormatter.formatDate(
                          appointment.nextDate,
                          "DDDD DD. MMMM YYYY"
                        )
                      }}
                      <br />
                      {{ appointment.Time }}
                      Uhr
                    </p>
                  </template>
                  <template v-else-if="appointment.lastDate">
                    <p style="margin-top: 10px">
                      <b>Letzter Termin:</b>
                      <br />
                      {{
                        DateFormatter.formatDate(
                          appointment.lastDate,
                          "DDDD DD. MMMM YYYY"
                        )
                      }}
                      <br />
                      {{ appointment.Time }}
                      Uhr
                    </p>
                  </template>
                  <!-- <template v-for="n in 5" :key="n">
                  <div class="u-color-primary" v-if="appointment['Date' + n]">
                    {{
                      DateFormatter.formatDate(
                        new Date(appointment["Date" + n]),
                        "DDDD DD. MMMM YYYY HH:mm"
                      ) || appointment["Date" + n]
                    }}
                    Uhr
                  </div>
                </template> -->
                </ion-label>
                <div slot="end" class="ion-no-margin">
                  <template
                    v-if="
                      !$store.state.showLoading &&
                      getAppointmentStatus(appointment) === 'appointmentAccept'
                    "
                  >
                    <ion-button
                      fill="clear"
                      target="_blank"
                      size="large"
                      @click="
                        sendMessageToPartner('appointmentCancel', appointment)
                      "
                    >
                      <ion-icon
                        :icon="closeCircleOutline"
                        size="large"
                      ></ion-icon>
                    </ion-button>
                    <br />
                  </template>
                  <template v-if="appointment.CityLat && appointment.CityLng">
                    <ion-button
                      fill="clear"
                      :href="
                        'https://www.google.com/maps/search/?api=1&query=' +
                        appointment.CityLat +
                        ',' +
                        appointment.CityLng
                      "
                      target="_blank"
                      size="large"
                    >
                      <ion-icon
                        :src="require('@lib/assets/icons/map_marker.svg')"
                        size="large"
                      ></ion-icon>
                    </ion-button>
                    <br />
                  </template>
                  <ion-button
                    fill="clear"
                    target="_blank"
                    size="large"
                    @click="getAppointmentICalFile(appointment.AppointmentId)"
                  >
                    <ion-icon :icon="calendarOutline" size="large"></ion-icon>
                  </ion-button>
                  <template v-if="appointment.IsUserAppointment">
                    <br />
                    <ion-button
                      fill="clear"
                      size="large"
                      @click="
                        openDeleteDoctorModal(
                          undefined,
                          'Appointments',
                          appointment.AppointmentId
                        )
                      "
                    >
                      <ion-icon :icon="trashOutline" size="large"></ion-icon>
                    </ion-button>
                  </template>
                </div>
              </ion-item>
              <template
                v-if="
                  !$store.state.showLoading && !appointment.IsUserAppointment
                "
              >
                <ion-row v-if="!getAppointmentStatus(appointment)">
                  <ion-col>
                    <ion-button
                      expand="block"
                      @click="
                        sendMessageToPartner('appointmentAccept', appointment)
                      "
                      >Annehmen</ion-button
                    >
                  </ion-col>
                  <ion-col>
                    <ion-button
                      expand="block"
                      fill="outline"
                      @click="
                        sendMessageToPartner('appointmentDecline', appointment)
                      "
                      >Ablehnen</ion-button
                    >
                  </ion-col>
                </ion-row>
                <div
                  v-else-if="
                    getAppointmentStatus(appointment) === 'appointmentDecline'
                  "
                  style="color: var(--ion-color-danger)"
                >
                  Termin wurde abgelehnt
                </div>
                <div
                  v-else-if="
                    getAppointmentStatus(appointment) === 'appointmentCancel'
                  "
                  style="color: var(--ion-color-danger)"
                >
                  Termin wurde abgesagt
                </div>
              </template>
              <collapsible
                v-if="
                  appointment.Partner ||
                  appointment.Reason ||
                  $store.getters.cases[appointment.Id] ||
                  appointment.AppointmentSubject
                "
              >
                <template v-slot:title>
                  <b>Weitere Informationen</b>
                </template>
                <div class="ion-margin-bottom">
                  <div style="font-size: small; margin-top: 10px">
                    <div v-if="appointment.Partner">
                      Vereinbart durch: {{ appointment.Partner }}
                    </div>
                    <div v-if="appointment.AppointmentSubject">
                      Betreff: {{ appointment.AppointmentSubject }}
                    </div>
                    <div v-if="appointment.Reason">
                      {{
                        appointment.IsUserAppointment
                          ? "Notiz: "
                          : "Begründung: "
                      }}
                      {{ appointment.Reason }}
                    </div>
                    <div v-if="$store.getters.cases[appointment.Id]">
                      <div>Geteilte Informationen:</div>
                      <div
                        v-for="fileIndex of $store.getters.cases[appointment.Id]
                          ?.files"
                        :key="fileIndex"
                      >
                        <a
                          href="#"
                          @click.prevent="
                            downloadFile(
                              $store.state.files[fileIndex].Id,
                              $store.state.files[fileIndex].Name,
                              $store.state.files[fileIndex].MimeType
                            )
                          "
                          >{{ $store.state.files[fileIndex].Name }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </collapsible>
            </div>
          </ion-list>
        </template>
        <template v-else-if="selectedSegment === 'doctors'">
          <p v-if="!$store.state.showLoading && doctors.length === 0">
            Sie haben aktuell noch keine Ärzte gespeichert.
          </p>
          <template v-else>
            <ion-searchbar
              placeholder="Arzt finden"
              v-model="doctorSearch"
            ></ion-searchbar>
            <p v-if="filteredDoctors.length === 0">
              Kein Arzt gefunden. Bitte versuchen Sie einen anderen Suchbegriff.
            </p>
            <ion-list v-else lines="none">
              <div
                v-for="(doctor, doctorIndex) in filteredDoctors"
                :key="doctorIndex"
                class="u-border"
              >
                <ion-item>
                  <ion-label class="ion-text-wrap">
                    <h2>
                      <b v-if="doctor.Type === 'clinic'">{{
                        doctor.Clinicname
                      }}</b>
                      <b v-else
                        >{{ doctor.Surname }} {{ doctor.Firstname
                        }}{{ doctor.Title ? `, ${doctor.Title}` : "" }}</b
                      >
                    </h2>
                    <div style="margin: 5px 0">
                      <template v-if="doctor.Type === 'clinic'">
                        <div v-if="doctor.Clinicdivision">
                          Abteilung: {{ doctor.Clinicdivision }}
                        </div>
                        <div v-if="doctor.Firstname || doctor.Surname">
                          Behandelnder Arzt: {{ doctor.Title }}
                          {{ doctor.Firstname }} {{ doctor.Surname }}
                        </div>
                      </template>
                      <div v-if="doctor.Specialty">{{ doctor.Specialty }}</div>
                      {{ doctor.Street }} {{ doctor.Housenumber }}<br />
                      {{ doctor.Zip }} {{ doctor.City }}
                    </div>
                    <div>
                      <a :href="'mailto:' + doctor.Email">{{ doctor.Email }}</a>
                    </div>
                    <div>
                      <a :href="'tel:' + doctor.Phone">{{ doctor.Phone }}</a>
                    </div>
                    <template v-if="doctor.lastDate">
                      <p style="margin-top: 10px">
                        <b>Letzter Termin:</b>
                        <br />
                        {{
                          DateFormatter.formatDate(
                            doctor.lastDate,
                            "DDDD DD. MMMM YYYY"
                          )
                        }}
                        <br />
                        {{ doctor.Time }}
                        Uhr
                      </p>
                    </template>
                  </ion-label>
                  <div slot="end" class="ion-no-margin">
                    <ion-button
                      v-if="doctor.CityLat && doctor.CityLng"
                      fill="clear"
                      :href="
                        'https://www.google.com/maps/search/?api=1&query=' +
                        doctor.CityLat +
                        ',' +
                        doctor.CityLng
                      "
                      target="_blank"
                      size="large"
                    >
                      <ion-icon
                        :src="require('@lib/assets/icons/map_marker.svg')"
                        size="large"
                      ></ion-icon>
                    </ion-button>
                    <br />
                    <ion-button
                      fill="clear"
                      size="large"
                      @click="openAddDoctorModal(doctor)"
                    >
                      <ion-icon :icon="pencilOutline" size="large"></ion-icon>
                    </ion-button>
                    <br />
                    <ion-button
                      fill="clear"
                      size="large"
                      @click="openAddDoctorModal(doctor, true)"
                    >
                      <ion-icon
                        :icon="require('@lib/assets/icons/calendar-add.svg')"
                        size="large"
                      ></ion-icon>
                    </ion-button>
                  </div>
                </ion-item>
                <collapsible v-if="doctor.Partner || doctor.Reason">
                  <template v-slot:title>
                    <b>Weitere Informationen</b>
                  </template>
                  <div class="ion-margin-bottom">
                    <div style="font-size: small; margin-top: 10px">
                      <div v-if="doctor.Partner">
                        Vorgeschlagen von: {{ doctor.Partner }}
                      </div>
                      <div v-if="doctor.Reason">Notiz: {{ doctor.Reason }}</div>
                    </div>
                  </div>
                </collapsible>
              </div>
            </ion-list>
          </template>
        </template>
        <template v-else-if="selectedSegment === 'proposed'">
          <p v-if="!$store.state.showLoading && proposed.length === 0">
            Sie haben aktuell keine Vorschläge.
          </p>
          <ion-list v-else lines="none">
            <template
              v-for="(doctor, doctorIndex) in proposed"
              :key="doctorIndex"
            >
              <ion-item :detail="false">
                <ion-label class="ion-text-wrap">
                  <h2>
                    <b v-if="doctor.Type === 'clinic'">{{
                      doctor.Clinicname
                    }}</b>
                    <b v-else
                      >{{ doctor.Surname }} {{ doctor.Firstname }},
                      {{ doctor.Title }}</b
                    >
                  </h2>
                  <div style="margin: 5px 0">
                    <template v-if="doctor.Type === 'clinic'">
                      <div v-if="doctor.Clinicdivision">
                        Abteilung: {{ doctor.Clinicdivision }}
                      </div>
                      <div v-if="doctor.Firstname || doctor.Surname">
                        Behandelnder Arzt: {{ doctor.Title }}
                        {{ doctor.Firstname }} {{ doctor.Surname }}
                      </div>
                    </template>
                    <div v-if="doctor.Specialty">{{ doctor.Specialty }}</div>
                    {{ doctor.Street }} {{ doctor.Housenumber }}<br />
                    {{ doctor.Zip }} {{ doctor.City }}
                  </div>
                  <div>
                    <a :href="'mailto:' + doctor.Email">{{ doctor.Email }}</a>
                  </div>
                  <div>
                    <a :href="'tel:' + doctor.Phone">{{ doctor.Phone }}</a>
                  </div>
                  <div style="font-size: small; margin-top: 10px">
                    <div v-if="doctor.Partner">
                      Vorgeschlagen von: {{ doctor.Partner }}
                    </div>
                    <div v-if="doctor.Reason">
                      Begründung: {{ doctor.Reason }}
                    </div>
                  </div>
                </ion-label>
                <div slot="end" class="ion-no-margin">
                  <ion-button
                    v-if="doctor.CityLat && doctor.CityLng"
                    fill="clear"
                    :href="
                      'https://www.google.com/maps/search/?api=1&query=' +
                      doctor.CityLat +
                      ',' +
                      doctor.CityLng
                    "
                    target="_blank"
                    size="large"
                  >
                    <ion-icon
                      :src="require('@lib/assets/icons/map_marker.svg')"
                      size="large"
                    ></ion-icon>
                  </ion-button>
                  <!-- <br />
                  <ion-button
                    fill="clear"
                    @click.prevent="moveDoctor(doctor.DoctorId)"
                    size="large"
                    ><ion-icon
                      :icon="personAddOutline"
                      slot="icon-only"
                      size="large"
                  /></ion-button>
                  <br />
                  <ion-button
                    fill="clear"
                    @click.prevent="
                      openDeleteDoctorModal(doctor.DoctorId, 'Proposed')
                    "
                    size="large"
                    ><ion-icon
                      :icon="trashOutline"
                      slot="icon-only"
                      size="large"
                  /></ion-button> -->
                </div>
              </ion-item>
              <template v-if="!$store.state.showLoading">
                <ion-row v-if="!getProposedStatus(doctor)">
                  <ion-col>
                    <ion-button
                      expand="block"
                      @click="sendMessageToPartner('proposedAccept', doctor)"
                      >Annehmen</ion-button
                    >
                  </ion-col>
                  <ion-col>
                    <ion-button
                      expand="block"
                      fill="outline"
                      @click="sendMessageToPartner('proposedDecline', doctor)"
                      >Ablehnen</ion-button
                    >
                  </ion-col>
                </ion-row>
              </template>
              <div class="u-border"></div>
            </template>
          </ion-list>
        </template>
      </ion-grid>
      <template
        v-if="
          selectedSegment === 'doctors' || selectedSegment === 'appointments'
        "
      >
        <add-fab :getDoctors="getDoctors"></add-fab>
      </template>
    </ion-content>
  </ion-page>
</template>

<script>
import { apiListFiles } from "@/api/file";
import { apiSendMessageToPartner } from "@/api/message";
import { apiDeleteDoctor } from "@/api/user";
import AddDoctorModal from "@/components/AddDoctorModal";
import AlertModal from "@/components/AlertModal.vue";
import Collapsible from "@/components/Collapsible";
import { useMessage } from "@/composables/useMessage";
import { file } from "@/mixins/file";
import axios from "@/plugins/axios";
import { appOrigin } from "@/utils/basics";
import { DateFormatter } from "@/utils/basics/date";
import { FileOpener } from "@awesome-cordova-plugins/file-opener";
import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import {
  alertController,
  IonBackButton,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRow,
  IonSearchbar,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
  modalController,
  onIonViewDidEnter,
  onIonViewWillEnter,
  toastController,
} from "@ionic/vue";
import {
  calendarOutline,
  chevronBack,
  closeCircleOutline,
  pencilOutline,
  personAddOutline,
  trashOutline,
} from "ionicons/icons";
import { useStore } from "vuex";
import { ref, computed } from "vue";
import { useDoctor } from "@/composables/useDoctor";
import AddFab from "@/components/AddFab.vue";

export default {
  mixins: [file],
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonButton,
    IonIcon,
    IonGrid,
    IonSegment,
    IonSegmentButton,
    IonTitle,
    IonSearchbar,
    IonBackButton,
    Collapsible,
    IonRow,
    IonCol,
    AddFab,
  },
  methods: {
    async openAddDoctorModal(doctor, addAppointment = false) {
      const modal = await modalController.create({
        component: AddDoctorModal,
        // cssClass: "c-autoheight-modal",
        componentProps: {
          doctor: doctor,
          addAppointment: addAppointment,
        },
      });
      modal.onDidDismiss().then((result) => {
        if (result?.data?.isEdited) {
          this.getDoctors();
        }
      });
      return modal.present();
    },
    async getAppointmentICalFile(id) {
      console.log(id);
      if (Capacitor.isNativePlatform()) {
        if (Capacitor.getPlatform() === "ios") {
          this.$store.commit("setShowLoading", true);
          const response = await axios.post(
            "?Mode=General&Function=DownloadAppointmentICalFile",
            {
              AppointmentId: id,
              GetLink: true,
            }
          );
          // this.$browser.addListener("browserPageLoaded", () => {
          //   console.log("browserPageLoaded");
          //   this.$browser.close();
          //   this.$browser.removeAllListeners();
          // });
          const calendarUrl =
            appOrigin +
            "/arag/api/?Mode=General&Function=DownloadAppointmentICalFileByToken&AppointmentId=" +
            id +
            "&Token=" +
            response.data.Result;

          this.$browser.open({
            url: calendarUrl,
            presentationStyle: "popover",
          });
        } else {
          this.$store.commit("setShowLoading", true);
          const response = await axios.post(
            "?Mode=General&Function=DownloadAppointmentICalFile",
            {
              AppointmentId: id,
              Base64: true,
            }
          );
          this.$store.commit("setShowLoading", true);
          const writeFileResult = await Filesystem.writeFile({
            path: "calendar.ics",
            data: response.data,
            directory: Directory.External,
          });
          await FileOpener.open(writeFileResult.uri, "text/calendar");
          this.$store.commit("setShowLoading", false);
        }
      } else {
        window.open(
          appOrigin +
            "/arag/api/?Mode=General&Function=DownloadAppointmentICalFile&AppointmentId=" +
            id,
          "_blank"
        );
      }
    },
    async listFiles() {
      await apiListFiles();
    },
    // async openDeleteDoctorModal(id, from) {
    //   const modal = await modalController.create({
    //     component: AlertModal,
    //     cssClass: "c-autoheight-modal",
    //     componentProps: {
    //       message: "Möchten Sie den Arzt wirklich löschen?",
    //       buttons: ["Ja", "Nein"],
    //     },
    //   });
    //   modal.onDidDismiss().then((data) => {
    //     if (data.data?.button === "Ja") {
    //       this.deleteDoctor(id, from);
    //     }
    //   });
    //   return modal.present();
    // },
  },
  async ionViewWillEnter() {
    const querySelectedSegment = this.$route.query.tab;
    if (querySelectedSegment) {
      this.selectedSegment = querySelectedSegment;
    }

    await this.listFiles();
  },
  setup() {
    const { getMessages } = useMessage();
    const store = useStore();

    const { getDoctors, getAppointmentStatus } = useDoctor();
    const appointments = computed(() => store.state.doctors.appointments || []);
    const doctors = computed(() => store.state.doctors.doctors || []);
    const proposed = computed(() => store.state.doctors.proposed || []);

    onIonViewWillEnter(async () => {
      store.commit("setShowLoading", true);
      await getMessages();
      getDoctors();
    });

    const getProposedStatus = (proposed) => {
      let result = "";
      if (proposed.ProposedId) {
        const foundConversation = store.state.conversations.find(
          (obj) => obj.caseId === proposed.Id
        );
        if (foundConversation) {
          const foundLastProposedMessage = foundConversation.messages.findLast(
            (obj) => obj.Meta?.proposedId === proposed.ProposedId
          );
          if (foundLastProposedMessage) {
            result = foundLastProposedMessage.Type;
          }
        }
      }
      return result;
    };

    const moveDoctor = async (id) => {
      // const modal = await modalController.create({
      //   component: AlertModal,
      //   cssClass: "c-autoheight-modal",
      //   componentProps: {
      //     message:
      //       "Möchten Sie den Eintrag zu Ihren Ärzten hinzufügen? Sie finden diese im Tab Ärzte.",
      //     buttons: ["Ja", "Nein"],
      //   },
      // });
      // modal.onDidDismiss().then(async (data) => {
      //   if (data.data?.button === "Ja") {
      store.commit("setShowLoading", true);
      const response = await axios.post("?Mode=General&Function=MoveDoctor", {
        Id: id,
        From: "Proposed",
        To: "User",
      });
      if (response.data.Status === "Success" && response.data.Result) {
        await getDoctors();
        // const toast = await toastController.create({
        //   message:
        //     "Erfolgreich zu Ihren Ärzten hinzugefügt. Sie finden diese im Tab Ärzte.",
        //   duration: 5000,
        // });
        // toast.present();
      }
      //   }
      // });
      // return modal.present();
    };

    const deleteDoctor = async (id, from, appointmentId) => {
      store.commit("setShowLoading", true);
      const data = {
        Id: id,
        From: from,
        AppointmentId: appointmentId,
      };
      const response = await apiDeleteDoctor(data);
      if (response.data.Status === "Success") {
        await getDoctors();
      }
    };

    const openDeleteDoctorModal = async (id, from, appointmentId) => {
      const modal = await modalController.create({
        component: AlertModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          message: "Möchten Sie den Eintrag wirklich löschen?",
          buttons: ["Ja", "Nein"],
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.data?.button === "Ja") {
          deleteDoctor(id, from, appointmentId);
        }
      });
      return modal.present();
    };

    const sendMessageToPartner = async (type, appointment) => {
      let message = "";
      if (type === "appointmentAccept") {
        message = `Möchten Sie den Termin annehmen und Partner ${appointment.Partner} rückbestätigen?`;
      } else if (type === "appointmentDecline") {
        message = `Möchten Sie den Termin ablehnen und Partner ${appointment.Partner} darüber informieren?`;
      } else if (type === "appointmentCancel") {
        message = "Möchten Sie den Termin absagen?";
      } else if (type === "proposedAccept") {
        message = `Möchten Sie den Eintrag zu Ihren Ärzten hinzufügen und Partner ${appointment.Partner} rückbestätigen? Sie finden Ihre Einträge im Tab Ärzte.`;
      } else if (type === "proposedDecline") {
        message = `Möchten Sie den Vorschlag ablehnen und Partner ${appointment.Partner} darüber informieren?`;
      } else {
        return;
      }
      const modal = await modalController.create({
        component: AlertModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          message: message,
          buttons: ["Ja", "Nein"],
        },
      });
      modal.onDidDismiss().then(async (data) => {
        if (data.data?.button === "Ja") {
          if (type === "proposedAccept") {
            await moveDoctor(appointment.DoctorId);
          } else if (type === "proposedDecline") {
            await deleteDoctor(appointment.DoctorId, "Proposed");
          }
          let response = null;
          if (type.startsWith("appointment")) {
            store.commit("setShowLoading", true);
            const person = `${appointment.Title || ""} ${
              appointment.Firstname || ""
            } ${appointment.Surname || ""}`;
            let message = "";
            if (appointment.AppointmentSubject) {
              message = appointment.AppointmentSubject + "\r\n";
            }
            message += `${
              appointment.Type === "clinic" ? appointment.Clinicname : person
            }
            ${appointment.Street || ""} ${appointment.Housenumber || ""}
            ${appointment.Zip || ""} ${appointment.City || ""}`;
            if (appointment.Reason) {
              message += "\r\n" + appointment.Reason;
            }
            message += `
            ${DateFormatter.formatDate(
              appointment.nextDate,
              "DDDD DD. MMMM YYYY"
            )}
            ${appointment.Time} Uhr`;
            response = await apiSendMessageToPartner(
              appointment.Id,
              type,
              message,
              {
                appointmentId: appointment.AppointmentId,
              }
            );
          } else if (type.startsWith("proposed")) {
            store.commit("setShowLoading", true);
            const person = `${appointment.Title} ${appointment.Firstname} ${appointment.Surname}`;
            const message = `${
              appointment.Type === "clinic" ? appointment.Clinicname : person
            }
            ${appointment.Street} ${appointment.Housenumber}
            ${appointment.Zip} ${appointment.City}`;
            response = await apiSendMessageToPartner(
              appointment.Id,
              type,
              message,
              {
                proposedId: appointment.ProposedId,
              }
            );
          }
          if (response?.data.Status === "Success") {
            store.commit("setShowLoading", true);
            await getMessages();
            const alert = await alertController.create({
              message: `Partner ${appointment.Partner} wurde verständigt.${
                ["appointmentDecline", "appointmentCancel"].includes(type)
                  ? " Es wird sich in Kürze jemand bei Ihnen melden."
                  : ""
              }`,
              buttons: ["OK"],
            });
            alert.present();
          }
        }
      });
      return modal.present();
    };

    return {
      chevronBack,
      calendarOutline,
      personAddOutline,
      pencilOutline,
      trashOutline,
      sendMessageToPartner,
      getProposedStatus,
      closeCircleOutline,
      appointments,
      doctors,
      proposed,
      getDoctors,
      openDeleteDoctorModal,
      getAppointmentStatus,
    };
  },
  data() {
    return {
      selectedSegment: "appointments",
      DateFormatter: DateFormatter,
      doctorSearch: "",
    };
  },
  computed: {
    filteredDoctors() {
      if (!this.doctorSearch) {
        return this.doctors;
      } else {
        const result = [];
        const doctorSearchTerms = this.doctorSearch
          .trim()
          .toLowerCase()
          .split(" ");
        for (const doctor of this.doctors) {
          for (const [termIndex, term] of doctorSearchTerms.entries()) {
            if (
              doctor.Surname?.toLowerCase().includes(term) ||
              doctor.Firstname?.toLowerCase().includes(term) ||
              doctor.Specialty?.toLowerCase().includes(term) ||
              doctor.Clinicname?.toLowerCase().includes(term) ||
              doctor.Clinicdivision?.toLowerCase().includes(term)
            ) {
              if (doctorSearchTerms.length === termIndex + 1) {
                result.push(doctor);
              }
            } else {
              break;
            }
          }
        }
        return result;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
ion-segment-button::before {
  opacity: 0;
}

.u-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.13);
  padding-bottom: 10px;
}
</style>
